// src/pages/PersonalBelongings/EditPersonalBelonging.js
import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import MainLayout from "../../../components/layout/MainLayout";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import PersonalBelongingsForm from "./PersonalBelongingsForm";
import {
    fetchPersonalBelonging,
    updatePersonalBelonging,
    clearCurrentBelonging,
} from "../../../store/slices/personalBelongingsSlice";

const EditPersonalBelonging = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const { state } = useLocation();
    const { caseId, patientId } = state || {};
    // console.log("ids : ", caseId, patientId);


    const { currentBelonging, isLoading } = useSelector(
        (state) => state.personalBelongings
    );

    const initialCaseId = state?.caseId || null;
    const initialPatientId = state?.patientId || null;

    const [formData, setFormData] = useState({
        caseId: initialCaseId,
        patientId: initialPatientId,
        clientName: "",
        // caregiverName: "",
        relation: "",
        belongings: [{ name: "" }],
        relativeName: "",
        trhStaffName: "",
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (id) dispatch(fetchPersonalBelonging(id));
        return () => dispatch(clearCurrentBelonging());
    }, [dispatch, id]);

    useEffect(() => {
        if (currentBelonging) {
            setFormData({
                caseId: currentBelonging.case_id || formData.caseId,
                patientId: currentBelonging.patient_id || formData.patientId,
                clientName: currentBelonging.client_name || "",
                // caregiverName: currentBelonging.caregiver_name || "",
                relation: currentBelonging.relation || "",
                belongings: Array.isArray(currentBelonging.items) && currentBelonging.items.length > 0
                    ? currentBelonging.items.map(item => ({ id: item.id, name: item.name }))
                    : [{ name: "" }],
                relativeName: currentBelonging.relative_name || "",
                trhStaffName: currentBelonging.trh_staff_name || "",
            });
        }
    }, [currentBelonging]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.clientName) newErrors.clientName = "Client name is required";
        // if (!formData.caregiverName)
        //     newErrors.caregiverName = "Caregiver name is required";
        if (
            !formData.belongings ||
            formData.belongings.length === 0 ||
            formData.belongings.some((b) => !b.name.trim())
        ) {
            newErrors.belongings = "Please list at least one belonging";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            Swal.fire({
                title: "Missing Fields",
                text: "Please fill all required fields before updating.",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return;
        }

        try {
            const payload = {
                case_id: formData.caseId,
                patient_id: formData.patientId,
                client_name: formData.clientName,
                // caregiver_name: formData.caregiverName,
                relation: formData.relation,
                items: formData.belongings.map((b) => ({ id: b.id, name: b.name })),
                relative_name: formData.relativeName,
                trh_staff_name: formData.trhStaffName,
            };

            // ✅ Use caseId in URL for updating

            // console.log("idddss : ", formData.caseId, formData.patientId);
            await dispatch(updatePersonalBelonging({ case_id: formData.caseId, data: payload })).unwrap();

            Swal.fire({
                title: "Updated!",
                text: "Personal belonging record updated successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            navigate(`/cases/${caseId}/profile`, { state: { patientId, caseId } });
        } catch (err) {
            console.error("Failed to update belonging:", err);
            Swal.fire({
                title: "Error!",
                text: "Failed to update personal belonging. Please try again.",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    if (isLoading || !formData)
        return <div className="text-center mt-5">Loading...</div>;

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                {/* Breadcrumbs + Print Button */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <Breadcrumbs />
                    <Link
                        to={`/personal-belongings/print/${id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-secondary"
                    >
                        <i className="ri-printer-line me-1"></i> Print
                    </Link>
                </div>

                <div className="card">
                    <div className="card-body">
                        {Object.keys(errors).length > 0 && (
                            <div className="alert alert-danger">
                                {Object.values(errors).map((err, i) => (
                                    <div key={i}>{err}</div>
                                ))}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <PersonalBelongingsForm
                                formData={formData}
                                setFormData={setFormData}
                                handleChange={handleChange}
                            />
                            <div className="col-12 d-flex justify-content-end mt-2">
                                <div className="mt-3 col-md-2 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary px-4">
                                        <i className="ri-edit-2-line me-1"></i> Update
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default EditPersonalBelonging;